<template>
  <div class="confirm_privacy">
    <p class="privacy-title">以下の規約に同意する場合はチェックしてください。</p>
    <a-checkbox-group v-model="statusCheck" class="privacy-items">
      <div v-for="(option, index) in options" :key="index">
        <a-checkbox v-if="!option.link&&option.value==='5'" :value="option.value" class="privacy-item-red">
          <span class="privacy-item-main-text">{{ option.label }}</span>
          <span v-if="option.label2" style="font-size: 12px; " class="privacy-item-text">{{option.label2}}</span>
          <span v-if="option.label3" style="font-size: 12px;" class="privacy-item-text">{{option.label3}}</span>
        </a-checkbox>
        <a-checkbox v-else-if="!option.link" :value="option.value" class="privacy-item">
          <span class="privacy-item-main-text">{{ option.label }}</span>
          <span v-if="option.label1" class="privacy-item-text">{{option.label1}}</span>
          <span v-if="option.label2" style="font-size: 12px; " class="privacy-item-text">{{option.label2}}</span>
        </a-checkbox
        >
        <a-checkbox :value="option.value" v-else class="privacy-item">
          <a :href="option.link" class="label-link" target="_blank">
            {{ option.label }}
            <i v-if="option.icon" class="ml-1 icon" :class="option.icon"></i
          ></a>
        </a-checkbox>
      </div>
    </a-checkbox-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statusCheck: []
    }
  },
  props: {
    creditPay: {
      type: String,
      default: 'local'
    }
  },
  computed: {
    options() {
      const isDosmetic = this.$route.path === '/register-confirmation'
      let terms = [
        {
          label: '本サイト会員規約',
          value: '0',
          link: 'https://bs.benefit-one.inc/contents/kiyaku/rule/',
          icon: 'icon-bor-full-screen'
        },
        {
          label: '個人情報第三者提供同意',
          value: '1',
          link: isDosmetic
            ? process.env.VUE_APP_TOP_DOMAIN + '/otherPage?other_id=prsnlInfAgree'
            : '/public-stay/menus/article',
          icon: 'icon-bor-full-screen'
        },
        { label: 'キャンセル規定への同意', value: '2' },
        {
          label: '旅行条件書への同意',
          value: '3',
          link: process.env.VUE_APP_TOP_DOMAIN + '/otherPage?other_id=kiyaku_cancel_travel',
          icon: 'icon-bor-full-screen'
        },
        { label: '未成年者のみの宿泊の場合、保護者同意を得ている。', label1: 'もしくは成人を含む予約である', label2: '※同意書の必要性は各施設へ事前にご確認ください', value: '4' }
      ]
      if (this.creditPay == "credit") {
        terms.push({ label: 'オンラインカード決済の場合、同行者申請の利用ができません。',label2: '※ご希望の場合は、現地決済のプランをご利用ください', label3: '※施設により現地決済プランの販売が無い場合がございます', value: '5' })
      }
      return terms
    },
    isAcceptPrivacy() {
      return this.statusCheck.length === this.options.length
    }
  },
  watch: {
    isAcceptPrivacy: {
      handler(val) {
        this.$emit('change', val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
